export const LSK_CDX_USER_INFO_HASH = "_2b91e330";
export const LSK_CDX_ACTIVE_SHEET = "_2be045ae";
export const LSK_CDX_IS_EMAIL_SIGNIN = "_6f0eeea6";
export const LSK_EMAIL_FOR_VERIFICATION = "_adf244d4";
export const LSK_EMAIL_FOR_SIGN_IN = "_98147725";
export const LSK_EMAIL_FOR_SIGN_UP = "_43b92ab3";
export const LSK_EMAIL_FOR_RESET_PASSWORD = "_49acccd8";
